import { render, staticRenderFns } from "./EditarContasAReceber.vue?vue&type=template&id=2c5e9da2"
import script from "./EditarContasAReceber.vue?vue&type=script&lang=js"
export * from "./EditarContasAReceber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports